import "./CustomTabs.css";

const CustomTabs = ({ tabs = [], activeTab, onTabChange }) => {
    return (
        <div className="custom-tabs-wrapper">
            {tabs.map((tab) => (
                <div key={tab.value} className={`custom-tab ${activeTab === tab.value ? "active" : ""}`} onClick={() => onTabChange(tab.value)}>
                    {tab.label}
                </div>
            ))}
        </div>
    );
};

export default CustomTabs;
